/**
 * Deterministic JSON serialization. Object keys are sorted recursively so the
 * same logical queryKey always produces the same string regardless of the
 * order properties were added.
 *
 * `@tanstack/react-query@5.26.3` does not export a public `hashKey` helper, so
 * we own this small utility. If react-query exports `hashKey` in a future
 * upgrade, swap to it for free alignment.
 */
export function stableStringify(value: unknown): string {
  return JSON.stringify(value, (_key, val: unknown) => {
    if (val && typeof val === "object" && !Array.isArray(val)) {
      const obj = val as Record<string, unknown>;
      return Object.keys(obj)
        .sort()
        .reduce<Record<string, unknown>>((acc, k) => {
          acc[k] = obj[k];
          return acc;
        }, {});
    }
    return val;
  });
}
